import React, { useEffect, useState } from "react";
import QueryString from "qs";
import Image from "next/image";
import apiService from "@/common/services/apiService";
import { scrollElementIntoView, toWebp } from "@/utils/common";
import PostPagination from "@/Components/pages/blog/blog-post/blog-pagination";
import Link from "next/link";

import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
dayjs.extend(advancedFormat);

interface Block {
  block: any;
  pageData: any;
}
const meta: any = {
  page: 1,
  pageCount: 1,
  pageSize: 12,
};
const AllStories: React.FC<Block> = ({ pageData }) => {
  const pageSize = 12;
  const [allStories, setStories] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pagination, setPagination] = useState(meta);
  const [pageLoader, setPageLoader] = useState(true);
  const { slug, query: collection } = pageData;
  const [filter, setFilter] = useState<any>({ slug: { $ne: slug } });
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;
  useEffect(() => {
    fetchStories(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchStories = async (page: number, withScroll = false) => {
    try {
      setPageLoader(true);
      const filterObj = filter;
      const title = ""; //search;
      if (withScroll) scrollElementIntoView("blocks.use-cases");
      if (title !== null && title !== "") {
        setFilter({ ...filter, ["title"]: { $containsi: title } });
        filterObj.title = { $containsi: title };
      } else {
        setFilter(filterObj);
        delete filterObj.title;
      }
      const query = QueryString.stringify(
        {
          filters: filterObj,
          populate: "deep, 10",
          pagination: { page: page ?? 1, pageSize: pageSize },
          sort: { publish_at: "DESC" },
        },
        { encodeValuesOnly: false },
      );

      const lst: any = await apiService.getapi1(
        collection + decodeURIComponent(query),
      );
      setPageLoader(false);
      setStories(lst.data.data);
      setPagination(lst.data.meta.pagination);
    } catch (error) {
      console.log("fetchStories ~ error:", error);
    }
  };

  const handlePageClick = (i: number) => {
    setCurrentPage(i);
    fetchStories(i + 1, true);
  };
  return (
    <>
      <section className="bg-white xl:py-[100px] lg:py-[80px] py-[56px]">
        <div className="container">
          {pageLoader && (
            <Image
              alt="loader"
              width={100}
              height={100}
              className="mx-auto"
              src="/images/bouncing-squares.svg"
            />
          )}
          <div className="grid 2xl:grid-cols-4 xl:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-x-[30px] lg:gap-y-[40px] gap-x-[24px] gap-y-[24px] min-h-screen">
            {!pageLoader &&
              allStories?.map((story: any, i: number) => (
                <Link
                  href={`/use-cases/${story.attributes.slug}`}
                  key={i}
                  className="border-b border-[#B0D9F7] group cursor-pointer"
                >
                  <div className="overflow-hidden">
                    {story?.attributes?.image?.data?.attributes?.url && (
                      <Image
                        alt="next"
                        width={390}
                        height={265}
                        src={toWebp(
                          baseUrl + story.attributes.image.data.attributes.url,
                        )}
                        className="w-full h-[265px] object-cover group-hover:scale-105 transition-all duration-500 ease-in-out"
                      />
                    )}
                  </div>
                  <div className="py-[16px]">
                    <h5 className="font-bold text-primary-text text-subtitle-2 mb-[16px] group-hover:text-[#000000] transition-colors duration-300">
                      {story.attributes.title}
                    </h5>
                    <p className="text-gray-300 font-regular text-subtitle-3">
                      {dayjs(story?.attributes?.date).format("DD-MM-YYYY")}
                    </p>
                  </div>
                </Link>
              ))}
          </div>

          {/* pagination */}
          {pagination?.total > 20 && (
            <PostPagination
              current={currentPage}
              changePage={handlePageClick}
              data={Math.ceil(pagination?.total / 12)}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default AllStories;
